import { RESEARCH_PIPELINE_STEPS } from "@/config/coAgentPrompts";
import { SOCIAL_PIPELINE_STEPS } from "@/config/socialCoAgentPrompts";
import { BRAND_PIPELINE_STEPS } from "@/config/brandCoAgentPrompts";
import { GROWTH_PIPELINE_STEPS } from "@/config/growthCoAgentPrompts";
import { GEO_PIPELINE_STEPS } from "@/config/geoCoAgentPrompts";
import { ECOMMERCE_PIPELINE_STEPS } from "@/config/ecommerceCoAgentPrompts";

export type CoAgentPipelineType =
  | "geo"
  | "ads"
  | "content"
  | "forge"
  | "products"
  | "brand-dna"
  // Legacy aliases
  | "research"
  | "social"
  | "brand"
  | "growth"
  | "ecommerce";

// Forge sections (used as step labels for sidebar navigation)
const FORGE_PIPELINE_STEPS = [
  "Startup Profile",
  "Problem",
  "Gap",
  "Solution",
  "Product",
  "Value Proposition",
  "Business Model",
  "Roadmap",
  "Team",
  "Market Analysis",
  "Competitor Analysis",
  "Branding",
  "Pitch Deck",
];

const STEP_LABELS: Record<CoAgentPipelineType, string[]> = {
  // Canonical names
  geo: GEO_PIPELINE_STEPS.map((s) => s.label),
  ads: GROWTH_PIPELINE_STEPS.map((s) => s.label),
  content: RESEARCH_PIPELINE_STEPS.map((s) => s.label),
  forge: FORGE_PIPELINE_STEPS,
  products: ECOMMERCE_PIPELINE_STEPS.map((s) => s.label),
  "brand-dna": BRAND_PIPELINE_STEPS.map((s) => s.label),
  // Legacy aliases
  research: RESEARCH_PIPELINE_STEPS.map((s) => s.label),
  social: SOCIAL_PIPELINE_STEPS.map((s) => s.label),
  brand: BRAND_PIPELINE_STEPS.map((s) => s.label),
  growth: GROWTH_PIPELINE_STEPS.map((s) => s.label),
  ecommerce: ECOMMERCE_PIPELINE_STEPS.map((s) => s.label),
};

export function getPipelineSteps(type: CoAgentPipelineType = "ads"): string[] {
  return STEP_LABELS[type];
}

export function getPipelineStepCount(type: CoAgentPipelineType = "ads"): number {
  return getPipelineSteps(type).length;
}

export function getPipelineMaxStepIndex(type: CoAgentPipelineType = "ads"): number {
  return getPipelineStepCount(type) - 1;
}
